import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-thong-ke-nhap-hoc-master',
  templateUrl: './thong-ke-nhap-hoc-master.component.html',
  styleUrls: ['./thong-ke-nhap-hoc-master.component.scss']
})
export class ThongKeNhapHocMasterComponent implements OnInit {
isSp : boolean= false;
  constructor() { 
  }

  deviceInfo = null;
  ngOnInit(): void {
    console.log(navigator.userAgent)

    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isSp= true;
    };
  }



}
